export const API_BASE_URL = process.env.NODE_ENV === 'production'
? 'https://ventaxpress.digitalnaen.com/'
: 'https://ventaxpress.digitalnaen.com/'